import { useEffect, useState } from 'react';

const BouncingImage = ({ width, imageLink }) => {
  const [bounce, setBounce] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setBounce((prev) => !prev);
    }, 1000); // Bounce every 1.5 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const bounceStyle = {
    transition: 'transform 1s ease-in-out',
    transform: bounce ? 'translateY(-10px)' : 'translateY(0)',
  };

  return (
    <img
      src={imageLink}
      alt="cat"
      className="h-auto"
      style={{ width: `${width}vw`, ...bounceStyle }}
    />
  );
};

export default BouncingImage;
